
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { EmailAccountSettingsClient, EmailAccountSettingsLimitedDTO } from "src/app/base/models/models.swagger.generated";

@Injectable({
  providedIn: 'root',
})
export class OutputEmailAccountsService {
  public outputEmailAccounts: EmailAccountSettingsLimitedDTO[];

  constructor(private emailAccountSettingsClient: EmailAccountSettingsClient) {
  }

  public loadOutputEmailAccounts(): Observable<EmailAccountSettingsLimitedDTO[]>  {
    return this.emailAccountSettingsClient.getOutEmailAccounts().pipe(
      tap((result: EmailAccountSettingsLimitedDTO[]) => {
        this.outputEmailAccounts = result;
      })
    );
  }
}